<template>
  <div class="devpage-page">
    <van-pull-refresh v-model="isLoading" @refresh="onReflash" class="devpage-index">
      <div v-if="devdata">
        <van-nav-bar left-arrow class="crystal-nav" @click-right="devconfigshow = true" @click-left="gotohome">
          <template #left>
            <van-icon name="arrow-left" size="20px" color="#475569" />
          </template>
          <template #right>
            <van-icon name="setting-o" size="20px" color="#94a3b8" />
          </template>
          <template #title>
            <div class="nav-title-wrap">
              <span class="nav-devname">{{ devdata.udname }}</span>
              <span class="nav-did">{{ did }}</span>
            </div>
          </template>
        </van-nav-bar>

        <van-action-sheet v-model="devconfigshow" :actions="actions" cancel-text="取消" @select="onSelect"
          :title="devdata.udname" class="crystal-actionsheet" />

        <DevGroup v-if="devgroupcard" :did="devdata.did" @configstatus="configstatus($event)"></DevGroup>
        <DevName v-if="devnamecard" :did="devdata.did" @configstatus="configstatus($event)"></DevName>
        <DevUnbind v-if="devunbindcard" :did="devdata.did" @configstatus="configstatus($event)"></DevUnbind>

        <div class="status-block" :class="statusBlockClass">
          <div class="status-inner">
            <div class="status-text">{{ statusMainText }}</div>
            <div class="status-sub">{{ statusSubText }}</div>
          </div>
        </div>

        <div class="quick-control">
          <!-- 待机/维护模式：三泵独立控制 + 一键换水 -->
          <button v-if="showPumpControls" class="ctrl-btn ctrl-btn--fw" :disabled="cmdLoading" @click="cmdPumpFw">
            补淡水
          </button>
          <button v-if="showPumpControls" class="ctrl-btn ctrl-btn--drain" :disabled="cmdLoading" @click="cmdPumpDrain">
            排海水
          </button>
          <button v-if="showPumpControls" class="ctrl-btn ctrl-btn--sw" :disabled="cmdLoading" @click="cmdPumpSw">
            补海水
          </button>
          <button v-if="showOneclickWc" class="ctrl-btn ctrl-btn--wc" :disabled="cmdLoading" @click="cmdOneclickWc">
            一键换水
          </button>
          <!-- 运行中：停止按钮 -->
          <button v-if="showStopButton" class="ctrl-btn ctrl-btn--danger ctrl-btn--full" :disabled="cmdLoading"
            @click="cmdStopAll">
            停止
          </button>
          <!-- 告警清除 -->
          <button v-if="gs === 1" class="ctrl-btn ctrl-btn--danger" :disabled="cmdLoading" @click="cmdClearErr">
            解除干烧
          </button>
        </div>

        <div v-if="hasError" class="error-banner">
          <div class="error-banner-left">
            <span class="iconfont icon-gongju error-banner-icon"></span>
          </div>
          <div class="error-banner-body">
            <div class="error-banner-title">设备告警</div>
            <div class="error-banner-text">{{ errorText }}</div>
          </div>
          <button v-if="canClearError" class="error-clear-btn" @click="cmdClearErr">清除</button>
        </div>

        <div class="content-area">
          <div class="info-card">
            <div class="info-item">
              <div class="info-item-left">
                <span class="iconfont icon-gongju info-icon" style="color:#fb923c"></span>
                <span class="info-label">维护开关</span>
              </div>
              <van-switch v-model="maintainToggle" size="22" :disabled="cmdLoading" />
            </div>
            <div class="info-divider"></div>
            <div class="info-item" v-for="(item, index) in statusItems" :key="index">
              <div class="info-item-left">
                <span class="iconfont" :class="item.icon" :style="{ color: item.color }"></span>
                <span class="info-label">{{ item.label }}</span>
              </div>
              <span class="info-value" :class="item.valueClass">{{ item.value }}</span>
            </div>
          </div>

          <div class="info-card">
            <div class="info-item info-item--link" @click="gotolog()">
              <div class="info-item-left">
                <span class="iconfont icon-rizhi info-icon" style="color:#2dd4bf"></span>
                <span class="info-label">查看日志</span>
              </div>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 4L10 8L6 12" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
            <div class="info-divider"></div>
            <div class="info-item info-item--link" @click="gotoconfig()">
              <div class="info-item-left">
                <span class="iconfont icon-sinaweibo18 info-icon" style="color:#2dd4bf;font-size:17px"></span>
                <span class="info-label">参数设置</span>
              </div>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 4L10 8L6 12" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
          </div>

          <TempChartKD2 v-if="tpc != null" :did="did" />
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import DevGroup from "../general/apidevgroup.vue";
import DevName from "../general/apidevname.vue";
import DevUnbind from "../general/apidevunbind.vue";
import TempChartKD2 from "../echarts/TempChartKD2.vue";

export default {
  name: "DevPageKD2",
  components: {
    DevGroup,
    DevName,
    DevUnbind,
    TempChartKD2,
  },
  data() {
    return {
      cmdLoading: false,

      connection: {
        url: "wss://dev.kudutech.cn/mqtt",
        clean: true,
        clientId: this.$route.query.did + this.generateUUID(),
        username: "KD-2web",
        password: "KD-2web",
      },
      subscription: {
        topic: "kd/dev/KD-2/" + this.$route.query.did + "/d2s",
        qos: 1,
      },
      client: {
        connected: false,
      },

      devconfigshow: false,
      devgroupcard: false,
      devnamecard: false,
      devunbindcard: false,

      isLoading: false,

      devdata: null,
      did: this.$route.query.did,
      actions: [
        { name: "更改分组", color: "#2dd4bf" },
        { name: "重命名", color: "#2dd4bf" },
        { name: "解绑", color: "#fb7185" },
      ],

    };
  },
  computed: {
    v() {
      return this.devdata && this.devdata.value ? this.devdata.value : {};
    },
    err() {
      return this.devdata && this.devdata.err ? this.devdata.err : [0];
    },
    hasError() {
      return this.err.length > 0 && this.err[0] !== 0;
    },
    canClearError() {
      /* 污水桶满自动清除，不显示清除按钮 */
      if (this.err.includes(-7)) return false;
      return this.hasError;
    },
    ws() { return this.v.ws != null ? this.v.ws : 0; },
    wcs() { return this.v.wcs != null ? this.v.wcs : 0; },
    wm() { return this.v.wm != null ? this.v.wm : 0; },
    wl() { return this.v.wl != null ? this.v.wl : 1; },
    wh() { return this.v.wh != null ? this.v.wh : 1; },
    gs() { return this.v.gs != null ? this.v.gs : 0; },
    tpc() { return this.v.tpc != null ? this.v.tpc : null; },
    tp() { return this.v.te != null ? this.v.te : null; },
    rtb() { return this.v.rtb != null ? this.v.rtb : 0; },
    wib() { return this.v.wib != null ? this.v.wib : 0; },
    mb() { return this.v.mb != null ? this.v.mb : 0; },
    wto() { return this.v.wto != null ? this.v.wto : 0; },
    wct() { return this.v.wct != null ? this.v.wct : 0; },
    rm() { return this.v.rm != null ? this.v.rm : 0; },
    wcMode() {
      /* 从 config 读取换水模式，默认间隔模式 */
      if (this.devdata && this.devdata.config && this.devdata.config.wc) {
        return Number(this.devdata.config.wc[0]) || 0;
      }
      return 0;
    },
    replenishEnable() {
      /* 从 config 读取自动补水开关，默认开 */
      if (this.devdata && this.devdata.config && this.devdata.config.re) {
        return Number(this.devdata.config.re[0]) === 1;
      }
      return true;
    },

    statusBlockClass() {
      if (this.wm === 1) return "status-block--maintain";
      if (this.hasError) return "status-block--alert";
      if (this.ws === 0) return "status-block--idle";
      if (this.ws === 1) return "status-block--replenish";
      if (this.ws === 2) return "status-block--maintain";
      if (this.ws >= 3) return "status-block--wc";
      return "status-block--idle";
    },
    statusMainText() {
      if (this.ws === 4 && this.wcs === 5) return "排海水中";
      const wsMap = { 0: "待机", 1: this.rm ? "补海水中" : "补淡水中", 2: "维护中", 3: "补淡水", 4: "排海水", 5: "补海水" };
      return wsMap[this.ws] || "未知状态";
    },
    statusSubText() {
      if (this.wm === 1) {
        if (this.mb > 0) {
          return `维护剩余 ${this.formatSec(this.mb)}`;
        }
        return "已切换至维护模式";
      }
      if (this.ws === 0) {
        return "";
      }
      if (this.ws === 1) {
        return this.wto > 0 ? `超时倒计时 ${this.formatSec(this.wto)}` : "";
      }
      if (this.ws === 4 && this.wcs === 5) {
        return this.wct > 0 ? `倒计时 ${this.formatSec(this.wct)}` : "";
      }
      if (this.ws >= 3) {
        const wcsMap = { 0: "空闲", 1: "补淡水中", 2: "排海水", 3: "补海水" };
        const stepText = this.wcs === 2 ? `换水(${this.wcs}/3)：${wcsMap[this.wcs] || "进行中"}` : `换水(${this.wcs}/3)`;
        const cd = this.ws === 4 ? this.wct : this.wto;
        return cd > 0 ? `${stepText} · 倒计时 ${this.formatSec(cd)}` : stepText;
      }
      return "";
    },

    statusTime() {
      const tm = this.v.tm;
      const wk = this.v.wk;
      if (tm == null) return "";
      const hours = Math.floor(tm / 10000);
      const minutes = Math.floor((tm % 10000) / 100);
      const seconds = tm % 100;
      const timeStr = [hours, minutes, seconds].map(n => String(n).padStart(2, "0")).join(":");
      const wkMap = { 1: "周一", 2: "周二", 3: "周三", 4: "周四", 5: "周五", 6: "周六", 7: "周日" };
      return `${timeStr} ${wkMap[wk] || ""}`;
    },
    errorText() {
      if (!this.hasError) return "";
      const errMap = {
        "-1": "补水超时：超过设定时间未停止，请检查水源",
        "-2": "换水补水超时：换水过程补水超过设定时间",
        "-3": "无水告警（干烧）：检测到无水运行，已停止水泵",
        "-4": "高温告警：水温超过高温阈值",
        "-5": "低温告警：水温低于低温阈值",
        "-7": "污水桶满：污水桶已满，请及时清理",
      };
      return this.err.map(e => errMap[String(e)] || `未知错误码 ${e}`).join("；");
    },

    statusItems() {
      const items = [];


      /* 维护模式：维护信息 + 补水 + 换水 */
      if (this.wm === 1) {
        items.push({
          icon: "icon-zidong1",
          color: "#f97316",
          label: "运行模式",
          value: `维护模式${this.mb > 0 ? ` (剩余${this.formatSec(this.mb)})` : ""}`,
          valueClass: "info-value--warn",
        });
      }
      /* 补水和换水状态一直显示 */
      items.push({
        icon: "icon-bushuitubiao",
        color: "#0ea5e9",
        label: "自动补水",
        value: this.replenishEnable ? "开" : "关",
        valueClass: this.replenishEnable ? "" : "info-value--inactive",
      });
      items.push({
        icon: "icon-huanshui",
        color: "#8b5cf6",
        label: "自动换水",
        value: this.wcMode === 1 ? "预约模式" : this.wcMode === 2 ? "手动模式" : "间隔模式",
        valueClass: "",
      });

      if (this.ws >= 3) {
        /* 独立排海水：不显示换水步骤 */
        if (this.wcs === 5) {
          items.push({
            icon: "icon-shuiwei",
            color: "#f97316",
            label: "排水状态",
            value: "独立排水中",
            valueClass: "info-value--active",
          });
        } else {
          const wcsTextMap = { 1: "补淡水", 2: "排水", 3: "补海水", 4: "停顿" };
          items.push({
            icon: "icon-shuiwei",
            color: "#8b5cf6",
            label: "换水步骤",
            value: `第${this.wcs}步/共3步 · ${wcsTextMap[this.wcs] || "进行中"}`,
            valueClass: "info-value--active",
          });
        }
      }

      items.push({
        icon: "icon-shuiwei",
        color: this.wh === 1 ? "#10b981" : "#ef4444",
        label: "水位状态",
        value: this.wh === 1 ? "正常" : "水位低",
        valueClass: this.wh === 0 ? "info-value--warn" : "",
      });

      if (this.tpc != null) {
        items.push({
          icon: "icon-wendu",
          color: "#fb7185",
          label: "温度",
          value: this.tpc != null ? `${this.tpc.toFixed(1)} °C` : "-- °C",
          valueClass: "",
        });
      }

      if (this.tp != null && this.tpc != null && Math.abs(this.tp - this.tpc) > 0.1) {
        items.push({
          icon: "icon-wendu",
          color: "#94a3b8",
          label: "原始温度",
          value: `${this.tp.toFixed(1)} °C`,
          valueClass: "info-value--inactive",
        });
      }

      if (this.gs === 1) {
        items.push({
          icon: "icon-gongju",
          color: "#ef4444",
          label: "干烧保护",
          value: "⚠️ 保护中",
          valueClass: "info-value--warn",
        });
      }

      /* 距下次补水 — 一直显示 */
      items.push({
        icon: "icon-daojishi",
        color: "#0ea5e9",
        label: "距下次补水",
        value: this.rtb > 0 ? this.formatHHMM(this.rtb) : "--:--",
        valueClass: "",
      });

      /* 距下次换水 — 三种换水模式都一直显示 */
      {
        var wcValue = "";
        if (this.wcMode === 2) {
          wcValue = "手动";
        } else if (this.wcMode === 1) {
          wcValue = "预约";
        } else {
          wcValue = this.wib > 0 ? this.formatHHMM(this.wib) : "--:--";
        }
        items.push({
          icon: "icon-daojishi",
          color: this.wcMode === 1 ? "#0ea5e9" : this.wcMode === 2 ? "#f97316" : "#8b5cf6",
          label: "距下次换水",
          value: wcValue,
          valueClass: "",
        });
      }



      return items;
    },

    showPumpControls() { return this.ws === 0 || this.ws === 2; },
    showStopButton() { return this.ws === 1 || this.ws >= 3; },
    showOneclickWc() { return this.ws === 0 && this.wm === 0; },
    showMaintainExit() { return this.wm === 1; },
    maintainToggle: {
      get() { return this.wm === 1; },
      set(val) {
        if (val) {
          this.cmdMaintainEnter();
        } else {
          this.cmdMaintainExit();
        }
      },
    },
  },
  mounted() {
    this.GetDevData(this.did);
    this.createConnection();
    this.doSubscribe();
  },
  beforeDestroy() {
    if (this.client.connected) {
      try {
        this.client.end();
        this.client = { connected: false };
      } catch (error) { }
    }
  },
  methods: {
    generateUUID() {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === "function") {
        d += performance.now();
      }
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g, function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },
    createConnection() {
      const { url, ...options } = this.connection;
      try {
        if (!this.client.connected) {
          this.client = mqtt.connect(url, options);
        }
      } catch (error) { }
      this.client.on("connect", () => { console.log("MQTT connected for KD-2"); });
      this.client.on("error", (error) => { });
      this.client.on("message", (topic, message) => {
        var datastr = `${message}`.replace(/\'/g, '"');
        this.resolve_data(JSON.parse(datastr));
      });
    },
    doSubscribe() {
      try {
        const { topic, qos } = this.subscription;
        this.client.subscribe(topic, qos, (error, res) => {
          if (error) return;
        });
      } catch (error) {
        console.warn("MQTT subscribe failed:", error);
      }
    },
    resolve_data(data_buf) {
      console.log("KD-2 MQTT received:", data_buf);
      if (data_buf["m_type"] === "heart" || data_buf["m_type"] === "reconfig") {
        this.devdata.value = data_buf.value;
        this.devdata.err = data_buf.err || [0];
        this.devdata.config = data_buf.config;
        if (data_buf.sta) {
          this.devdata.sta = data_buf.sta;
        }
        this.$forceUpdate();
      }
    },
    getMsgId() {
      return this.generateUUID();
    },
    sendCmd(actData) {
      this.cmdLoading = true;
      const qs = require("qs");
      var configBuf = JSON.stringify({ act: actData });
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({
          did: this.devdata.did,
          d_type: "KD-2",
          config: configBuf,
        }))
        .then((response) => {
          this.cmdLoading = false;
          this.GetDevData(this.did);
          if (response.data.error_code !== 0) {
            this.$notify({ type: "danger", message: "指令发送失败" });
          } else {
            this.$notify({ type: "success", message: "指令已发送" });
          }
        })
        .catch((error) => {
          this.cmdLoading = false;
          this.GetDevData(this.did);
          this.$notify({ type: "danger", message: "指令发送失败" });
        });
    },
    cmdReplenishStart() { this.sendCmd({ replenish: { val: 1 } }); },
    cmdReplenishStop() { this.sendCmd({ replenish: { val: 0 } }); },
    cmdWcStart() { this.sendCmd({ wc: { val: 1 } }); },
    cmdWcStop() { this.sendCmd({ wc: { val: 0 } }); },
    cmdMaintainEnter() { this.sendCmd({ maintain: { val: 1 } }); },
    cmdMaintainExit() { this.sendCmd({ maintain: { val: 0 } }); },
    cmdClearErr() { this.sendCmd({ clr_err: 1 }); },
    /* 三泵独立控制 + 停止 */
    cmdPumpFw() { this.sendCmd({ pump_fw: { val: 1 } }); },
    cmdPumpDrain() { this.sendCmd({ pump_drain: { val: 1 } }); },
    cmdPumpSw() { this.sendCmd({ pump_sw: { val: 1 } }); },
    cmdStopAll() { this.sendCmd({ stop_all: 1 }); },
    cmdOneclickWc() { this.sendCmd({ oneclick_wc: 1 }); },

    devrefresh() {
      this.isLoading = true;
      const qs = require("qs");
      var databuf = JSON.stringify({ a: 2 });
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({
          did: this.devdata.did,
          d_type: "KD-2",
          config: databuf,
        }))
        .then((response) => {
          this.isLoading = false;
          if (response.data.error_code === 0) {
            this.GetDevData(this.did);
          }
        })
        .catch((error) => { this.isLoading = false; });
    },
    onSelect(item) {
      this.devconfigshow = false;
      if (item.name === "重命名") { this.devnamecard = true; }
      else if (item.name === "更改分组") { this.devgroupcard = true; }
      else if (item.name === "解绑") { this.devunbindcard = true; }
    },
    configstatus(statu) {
      this.devgroupcard = false;
      this.devnamecard = false;
      this.devunbindcard = false;
      this.GetDevData(this.did);
      if (statu === true) { this.$toast.success("设置成功"); }
    },
    GetDevData(did) {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/one", qs.stringify({ did: did }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.isLoading = false;
            this.devdata = response.data;
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          } else {
            this.$router.push({ path: "/devlist" });
          }
        });
    },
    formatHHMM(sec) {
      if (sec == null || sec <= 0) return "--:--";
      var h = Math.floor(sec / 3600);
      var m = Math.floor((sec % 3600) / 60);
      return String(h).padStart(2, "0") + ":" + String(m).padStart(2, "0");
    },
    formatSec(sec) {
      if (sec == null || sec <= 0) return "0秒";
      if (sec < 60) return `${sec}秒`;
      if (sec < 3600) return `${Math.floor(sec / 60)}分${sec % 60}秒`;
      const h = Math.floor(sec / 3600);
      const m = Math.floor((sec % 3600) / 60);
      return `${h}时${m}分`;
    },
    onReflash() { this.devrefresh(); },
    gotohome() { this.$router.go(-1); },
    gotoconfig() { this.$router.push({ name: "KD2Config", query: { did: this.did } }); },
    gotolog() { this.$router.push({ name: "KD2Log", query: { did: this.did, udname: this.devdata ? this.devdata.udname : "" } }); },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Noto+Sans+SC:wght@400;500;600;700&display=swap");

.crystal-nav {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9;
}

.crystal-nav .van-nav-bar__title {
  max-width: 70%;
}

.nav-title-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.3;
}

.nav-devname {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.nav-did {
  font-size: 11px;
  color: #94a3b8;
}

.crystal-actionsheet .van-action-sheet__header {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}
</style>

<style scoped>
.devpage-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(145deg, #f0f9ff 0%, #fdf2f8 35%, #f0fdf4 100%);
  font-family: "Inter", "Noto Sans SC", sans-serif;
}

.devpage-index {
  background: transparent !important;
  padding-bottom: 20px;
  min-height: 100vh;
  min-height: 100dvh;
}

.status-block {
  position: relative;
  margin: 12px 12px 0;
  border-radius: 18px;
  padding: 40px 24px;
  text-align: center;
  overflow: hidden;
  transition: all 0.4s ease;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04);
}

.status-block--idle {
  background: linear-gradient(135deg, #2dd4bf, #14b8a6);
  color: #fff;
}

.status-block--replenish {
  background: linear-gradient(135deg, #60a5fa, #3b82f6);
  color: #fff;
}

.status-block--wc {
  background: linear-gradient(135deg, #a78bfa, #8b5cf6);
  color: #fff;
}

.status-block--maintain {
  background: linear-gradient(135deg, #fb923c, #f97316);
  color: #fff;
}

.status-block--alert {
  background: linear-gradient(135deg, #f87171, #ef4444);
  color: #fff;
}

.status-block--replenish::before,
.status-block--wc::before,
.status-block--maintain::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle at 30% 40%, rgba(255, 255, 255, 0.08) 0%, transparent 60%);
  animation: statusShimmer 4s ease-in-out infinite;
}

@keyframes statusShimmer {

  0%,
  100% {
    transform: translate(0, 0);
  }

  50% {
    transform: translate(10%, 10%);
  }
}

.status-inner {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.status-text {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 1px;
}

.status-sub {
  font-size: 14px;
  font-weight: 400;
  opacity: 0.85;
  margin-top: 4px;
}

.status-time {
  font-size: 12px;
  font-weight: 400;
  opacity: 0.65;
  margin-top: 6px;
}

.error-banner {
  margin: 10px 12px 0;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-left: 4px solid #ef4444;
  border-radius: 12px;
  padding: 12px 14px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.error-banner-left {
  flex-shrink: 0;
}

.error-banner-icon {
  font-size: 18px;
  color: #ef4444;
}

.error-banner-body {
  flex: 1;
  min-width: 0;
}

.error-banner-title {
  font-size: 13px;
  font-weight: 600;
  color: #991b1b;
  margin-bottom: 2px;
}

.error-banner-text {
  font-size: 12px;
  color: #b91c1c;
  line-height: 1.5;
}

.error-clear-btn {
  flex-shrink: 0;
  height: 28px;
  padding: 0 14px;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  background: #ef4444;
  color: #fff;
  transition: transform 0.15s, box-shadow 0.15s;
  white-space: nowrap;
}

.error-clear-btn:active {
  transform: scale(0.95);
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
}

.content-area {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-card {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.info-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 16px;
  min-height: 20px;
}

.info-item--link {
  cursor: pointer;
  transition: background 0.15s;
}

.info-item--link:active {
  background: #f8fafc;
}

.info-item-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.info-icon {
  font-size: 17px;
  flex-shrink: 0;
}

.info-label {
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
  white-space: nowrap;
}

.info-value {
  font-size: 13px;
  font-weight: 500;
  color: #1e293b;
  text-align: right;
  margin-left: 12px;
  flex-shrink: 0;
  max-width: 55%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.info-value--active {
  color: #0d9488;
}

.info-value--inactive {
  color: #94a3b8;
}

.info-value--warn {
  color: #ef4444;
}

.info-divider {
  height: 1px;
  background: #f1f5f9;
  margin: 0 16px;
}

.quick-control {
  margin: 10px 12px 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  background: #ffffff;
  border-radius: 16px;
  padding: 12px 14px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
}

.ctrl-btn {
  height: 32px;
  padding: 0 12px;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: transform 0.15s, box-shadow 0.15s, opacity 0.15s;
}

.ctrl-btn:active {
  transform: scale(0.95);
}

.ctrl-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.ctrl-btn--primary {
  background: rgba(45, 212, 191, 0.15);
  color: #0d9488;
}

.ctrl-btn--primary:not(:disabled):active {
  box-shadow: 0 2px 8px rgba(45, 212, 191, 0.25);
}

.ctrl-btn--fw {
  background: rgba(56, 189, 248, 0.15);
  color: #0284c7;
}

.ctrl-btn--fw:not(:disabled):active {
  box-shadow: 0 2px 8px rgba(56, 189, 248, 0.25);
}

.ctrl-btn--drain {
  background: rgba(251, 146, 60, 0.15);
  color: #ea580c;
}

.ctrl-btn--drain:not(:disabled):active {
  box-shadow: 0 2px 8px rgba(251, 146, 60, 0.25);
}

.ctrl-btn--sw {
  background: rgba(52, 211, 153, 0.15);
  color: #059669;
}

.ctrl-btn--sw:not(:disabled):active {
  box-shadow: 0 2px 8px rgba(52, 211, 153, 0.25);
}

.ctrl-btn--wc {
  background: rgba(167, 139, 250, 0.15);
  color: #7c3aed;
}

.ctrl-btn--wc:not(:disabled):active {
  box-shadow: 0 2px 8px rgba(167, 139, 250, 0.25);
}

.ctrl-btn--danger {
  background: rgba(239, 68, 68, 0.12);
  color: #dc2626;
}

.ctrl-btn--danger:not(:disabled):active {
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.25);
}

.ctrl-btn--warning {
  background: rgba(251, 146, 60, 0.15);
  color: #ea580c;
}

.ctrl-btn--warning:not(:disabled):active {
  box-shadow: 0 2px 8px rgba(251, 146, 60, 0.25);
}

.ctrl-btn--full {
  grid-column: 1 / -1;
}

:deep(.van-switch--on) {
  background: #2dd4bf !important;
}
</style>
